<div class="text-center">
  <h3 *ngIf="data.title">{{data.title}}</h3>
  <div class="t-left mt-3" [innerHTML]="data.content"></div>

  <button class="primary-btn mt-5" mat-raised-button (click)="close()">{{data.btn}}</button>
</div>
